import { Component } from '@angular/core';

@Component({
    templateUrl: './kyc-denied.component.html',
    styleUrls: ['./kyc-denied.component.scss']
})
export class KycDeniedComponent { }
